// extracted by mini-css-extract-plugin
module.exports = {"container":"_0a3a94f455--container--Pg4L2"};